import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type PeriodStatusBadgeProps = {
  status: string;
};

const STATUS_BADGE_COLOR: Record<
  string,
  'neutral' | 'primary' | 'success' | 'warning' | 'failure'
> = {
  Open: 'success',
  Closed: 'primary',
  Locked: 'warning',
  Archived: 'neutral',
};

export const PeriodStatusBadge = ({ status }: PeriodStatusBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge
      color={STATUS_BADGE_COLOR[status] ?? 'neutral'}
      className="@PeriodStatusBadge"
    >
      {t.periodsListView.statusTypes[status] ?? status}
    </Badge>
  );
};
